import * as pdfjsLib from 'pdfjs-dist';

// Configure the PDF.js worker.
// Using the static worker from /public avoids dynamic import failures
// and the 'Setting up fake worker failed' error in Vite.
if (!pdfjsLib.GlobalWorkerOptions.workerSrc) {
  if (typeof window !== 'undefined') {
    pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';
  } else {
    pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@5.2.133/build/pdf.worker.min.mjs';
  }
}

export { pdfjsLib };
export default pdfjsLib;
